import { useEffect, useState } from 'react';

/**
 * Forces a re-render every `ms`. Useful for values that decay with wall-clock
 * time rather than with data events — e.g. `Screen.isLive()`, which compares
 * `lastSeen` to `Date.now()`: when a screen goes silent it stops writing, so no
 * Firestore snapshot ever arrives to trigger a re-render and the UI would stay
 * "LIVE" forever. A periodic tick re-evaluates those reads so the state ages out.
 */
export function useTick(ms: number) {
    const [, setTick] = useState(0);
    useEffect(() => {
        const id = setInterval(() => setTick((n) => n + 1), ms);
        return () => clearInterval(id);
    }, [ms]);
}
